import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Avatar } from '../avatar';
import { FlexBox } from '../box';
import { styled } from '../styled';
import { getPaletteColor } from '../theme';
import { Typography } from '../typography';
const BubbleContainer = styled(FlexBox)(({ $align }) => ({
    alignSelf: $align === 'left' ? 'flex-start' : 'flex-end',
    maxWidth: '75%'
}));
const Bubble = styled(FlexBox)(({ theme, $variant }) => ({
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    backgroundColor: $variant === 'default'
        ? getPaletteColor(theme, 'background.default')
        : getPaletteColor(theme, 'primary.main'),
    color: $variant === 'default'
        ? getPaletteColor(theme, 'text.primary')
        : getPaletteColor(theme, 'primary.contrastText')
}));
export const ChatBubble = (props) => {
    const { align, variant, senderName, avatar, timestamp, children, className, ...rest } = props;
    const resolvedVariant = variant ?? (align === 'right' ? 'primary' : 'default');
    const avatarElement = avatar ? _jsx(Avatar, { ...avatar, size: 24 }) : null;
    return (_jsxs(BubbleContainer, { "$align": align, stack: true, gap: 0.5, className: className, "data-role": rest['data-role'] ?? 'chat-bubble', "data-role-value": rest['data-role-value'], children: [(senderName || avatar) && (_jsxs(FlexBox, { gap: 1, vAlign: "center", hAlign: align === 'left' ? 'flex-start' : 'flex-end', children: [align === 'left' && avatarElement, senderName && (_jsx(Typography, { variant: "caption", color: "text.secondary", children: senderName })), align === 'right' && avatarElement] })), _jsxs(Bubble, { "$variant": resolvedVariant, children: [typeof children === 'string' ? (_jsx(Typography, { variant: "body2", color: "inherit", children: children })) : (children), timestamp && (_jsx(Typography, { variant: "caption", color: resolvedVariant === 'primary'
                            ? 'primary.contrastText'
                            : 'text.disabled', textAlign: "right", children: timestamp }))] })] }));
};
